module.exports = __webpack_public_path__ + "王嘉平-e9ade0c7.png";